import { render, staticRenderFns } from "./PavementBody.vue?vue&type=template&id=f0d7ec0e&scoped=true&"
import script from "./PavementBody.vue?vue&type=script&lang=js&"
export * from "./PavementBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d7ec0e",
  null
  
)

export default component.exports